module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "footer__menu-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "footer__menu-list-item"
    }, [(item.to) ? _c('ext-link', _vm._b({
      staticClass: "menu-nav",
      on: {
        "click": function($event) {
          return _vm.$emit(item.event, $event)
        }
      }
    }, 'ext-link', item, false)) : _c('span', {
      staticClass: "menu-text"
    }, [_vm._v(_vm._s(item.text))])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd11c50","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/Footer.vue
// module id = 8f46e25a484278397022
// module chunks = 0